import { render } from "./ZsctWordLeft.vue?vue&type=template&id=540e84bc"
import script from "./ZsctWordLeft.vue?vue&type=script&lang=js"
export * from "./ZsctWordLeft.vue?vue&type=script&lang=js"

import "./ZsctWordLeft.vue?vue&type=style&index=0&id=540e84bc&lang=scss"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__